import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
  TextField, Grid, MenuItem, CircularProgress
} from '@mui/material';
import { updateTenantSubscriptionApi } from 'backendServices/ApiCalls';

const UpdateSubscriptionModal = ({ open, onClose, userId, GetUsersList, plan, closeMain, setalertData }) => {
  const [formData, setFormData] = useState({
    item_id: '',
    admin_transaction_password: ""
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (errors[e.target.name]) {
      setErrors({ ...errors, [e.target.name]: "" });
    }
  };

  const validate = () => {
    let tempErrors = {};
    if (!formData.item_id || formData.item_id === "Select Plan") {
      tempErrors.item_id = "Plan is required";
    }
    if (!formData.admin_transaction_password) {
      tempErrors.admin_transaction_password = "Transaction password is required";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;
    setLoading(true);
    // TODO: Connect correct API endpoint for update subscription
    try {
      // API integration to be hooked here
      updateTenantSubscriptionApi({ ...formData, id: userId }, (response) => {
        if (response?.data?.status === "error") {
          setalertData({
            show: true,
            message: "Error updating subscription",
            variant: "error"
          });
        } else {
          setalertData({
            show: true,
            message: "Subscription updated successfully",
            variant: "success"
          });
          onClose();
          closeMain();
          GetUsersList();
        }
        setLoading(false);
      }, (error) => {
        setalertData({
          show: true,
          message: error?.response?.data?.message || "Something went wrong please try again later",
          variant: "error"
        });
        setLoading(false);
      });
    } catch (error) {
      setalertData({
        show: true,
        message: "Something went wrong please try again later",
        variant: "error"
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!open) {
      setFormData({
        item_id: '',
        admin_transaction_password: ""
      });
      setErrors({});
    } else {
      setFormData((prev) => ({ ...prev, item_id: plan?.includes("Starter") ? "Starter-wl-akquise-EUR-Monthly" : "Business-wl-akquise-EUR-Monthly" }))
    }
  }, [open, plan]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Update Subscription</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              required
              label="Plan"
              name="item_id"
              value={formData.item_id}
              onChange={handleChange}
              error={!!errors.item_id}
              helperText={errors.item_id}
            >
              <MenuItem value="Select Plan" disabled>Select Plan</MenuItem>
              <MenuItem value="Basic-wl-akquise-EUR-Monthly">Basic-wl-akquise-EUR-Monthly</MenuItem>
              <MenuItem value="Starter-wl-akquise-EUR-Monthly">Starter-wl-akquise-EUR-Monthly</MenuItem>
              <MenuItem value="Business-wl-akquise-EUR-Monthly">Business-wl-akquise-EUR-Monthly</MenuItem>
              <MenuItem value="Basic-wl-akquise-EUR-Yearly">Basic-wl-akquise-EUR-Yearly</MenuItem>
              <MenuItem value="Starter-wl-akquise-EUR-Yearly">Starter-wl-akquise-EUR-Yearly</MenuItem>
              <MenuItem value="Business-wl-akquise-EUR-Yearly">Business-wl-akquise-EUR-Yearly</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              required
              label="Transaction Password"
              name="admin_transaction_password"
              type="password"
              value={formData.admin_transaction_password}
              onChange={handleChange}
              error={!!errors.admin_transaction_password}
              helperText={errors.admin_transaction_password}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? <CircularProgress size={24} /> : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateSubscriptionModal;
